<template>

    <div class="grid-wrapper category-footer">
        <p class="description">
            {{ description }}
        </p>
    </div>

</template>

<script>

    export default {
        name: 'category-header',
        props: {
            description: {
                type: String,
                default: ''
            }
        },
        methods: {}
    }
</script>

<style lang="scss" scoped>
    @import '@/assets/stylesheets/unstylished-headers.scss';
    @import '@/assets/stylesheets/variables.scss';

    .category-footer {
        margin-top: 100px;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        border-top: 1px solid #d5d5d5;

        .description {
            grid-column: 2 / 4;
            margin: 0;
            font-family: OpenSans;
            font-size: 1.6rem !important;
            line-height: 1.38;
            letter-spacing: 0.8px;
            text-align: center;
            color: #626467;
            padding-top: 50px;

            @media only screen and (max-width: 600px) {
                grid-column: 1 / 5;
            }
        }
    }

</style>
